var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { registerCustomElement } from '../utils/registerCustomElement';
import { styles } from './styles';
let Modal = class Modal extends LitElement {
    constructor() {
        super(...arguments);
        this._open = () => {
            this.dispatchEvent(new CustomEvent('open', { bubbles: true, composed: true }));
        };
        this._close = () => {
            this.dispatchEvent(new CustomEvent('close', { bubbles: true, composed: true }));
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this._open();
    }
    render() {
        return html `<div class="grain-modal">
      <div class="scrim" @click="${this._close}"></div>
      <div class="content">
        <slot></slot>
      </div>
    </div>`;
    }
};
Modal.styles = styles;
Modal = __decorate([
    registerCustomElement('grain-modal')
], Modal);
export { Modal };
